
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { RevPicker } from '@ds/components/Picker'
import { parse } from 'query-string'

import { MODAL_NAMES } from '@config/constants'
import { productGradesDescriptionFetch } from '@http/endpoints'
import { trackClick } from '@tracking/events'

import AsyncModal from '../AsyncModal'

import translations from './GradesModal.translations'
import GradeDescription from './components/GradeDescription'

export default {
  components: {
    AsyncModal,
    RevLink,
    RevIllustration,
    GradeDescription,
    RevPicker,
  },
  data() {
    return {
      gradesDescriptions: [],
      selectedGradeIndex: null,
    }
  },
  computed: {
    translations: () => translations,
    modalName: () => MODAL_NAMES.PRODUCT.GRADES,
    pickers() {
      return this.gradesDescriptions.map(({ backboxGrade }, index) => ({
        backboxGrade,
        selected: this.selectedGradeIndex === index,
      }))
    },
    description() {
      return this.gradesDescriptions[this.selectedGradeIndex]
    },
    image() {
      return this.description?.images?.[0] ?? null
    },
    details() {
      return this.description?.paragraphs ?? []
    },
  },
  methods: {
    async fetchGradesDescription() {
      const { payload } = await this.$store.dispatch('http/request', {
        request: productGradesDescriptionFetch,
        queryParams: {
          include_technical_comment: true,
        },
        pathParams: { id: this.$route.params.uuid },
      })

      const { l } = parse(this.$route.hash)
      const selectedGradeId = parseInt(l, 10)

      this.gradesDescriptions = payload
      this.selectedGradeIndex = this.gradesDescriptions.findIndex(
        (grade) => grade.backboxGrade.value === selectedGradeId,
      )
    },
    updateGrade(picker) {
      const newSelectedGradeIndex = this.gradesDescriptions.findIndex(
        (grade) => grade.backboxGrade.value === picker.backboxGrade.value,
      )

      if (newSelectedGradeIndex === this.selectedGradeIndex) {
        return
      }

      this.selectedGradeIndex = newSelectedGradeIndex

      trackClick({
        zone: 'grade_picker_modal',
        name: picker.backboxGrade.value,
      })
    },
  },
}
